export default __webpack_public_path__ + "static/media/description-dateFormat.5201c8af.png";